<template>
    <div class="loading-screen">
        <div class="loading-text">
            <i class="fad fa-spinner fa-spin"></i> Chargement en cours... {{ text }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingScreen',

        props: {
            text: {
                type: String,
                required: false,
            },
        },
    }
</script>
